(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-folie-hero"] && !Shopify.designMode) return;
  try {
    
  class HbFolieVideo extends HTMLElement {
    connectedCallback() {
      const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduit) return;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const tpl = this.querySelector(`template[data-video="${mobile ? 'mobile' : 'desktop'}"]`);
      if (!tpl) return;
      const cadre = this.querySelector('.hb-folie-video__cadre');
      const frag = tpl.content.cloneNode(true);
      const video = frag.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
      cadre.appendChild(frag);
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    }
  }
  if (!customElements.get('hb-folie-video')) customElements.define('hb-folie-video', HbFolieVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-folie-semaine"] && !Shopify.designMode) return;
  try {
    
  class HbFolieSemaine extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-editeur')) return;
      const panneaux = [...this.querySelectorAll('.hb-semaine__panneau')];
      if (panneaux.length < 2) return;
      let jour;
      try {
        jour = new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Tunis' }).format(new Date());
      } catch (e) {
        jour = new Date().toISOString().slice(0, 10);
      }
      let choisi = panneaux.find((p) => p.dataset.debut <= jour && jour <= p.dataset.fin);
      if (!choisi) {
        const apres = panneaux.filter((p) => p.dataset.fin && p.dataset.fin < jour);
        choisi = apres.length === panneaux.length ? panneaux[panneaux.length - 1] : panneaux[0];
      }
      panneaux.forEach((p) => {
        p.hidden = p !== choisi;
      });
    }
  }
  if (!customElements.get('hb-folie-semaine')) customElements.define('hb-folie-semaine', HbFolieSemaine);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-offre-kit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const input = event.target instanceof Element ? event.target.closest('[data-hb-offre-input]') : null;
    if (!input) return;
    const root = input.closest('[data-hb-offre]');
    const button = root && root.querySelector('[data-hb-add]');
    if (!button) return;
    button.setAttribute('data-variant-id', input.value);
    const total = root.querySelector('[data-hb-offre-total]');
    if (total) total.textContent = input.dataset.price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
